"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImportMember = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _classCallCheck2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _memberImportValidator = require("@/utils/member-import-validator");
var _checkExt = require("@/utils/check-ext");
var _user = require("@/api/user");
/**
 * 内部名形式の会員データを正規化し、GraphQL用のオブジェクトを生成するクラス。
 * MemberImportValidator.validate() でバリデーション済みの InternalMember を受け取ることを前提とする。
 */
var ImportMember = exports.ImportMember = /*#__PURE__*/function () {
  /**
   * @param {import('@/utils/member-import-validator').InternalMember} rawMember - バリデーション済みの会員データ（内部名形式）
   * @param {Object} options
   * @param {Object} options.zoneInfo - 団体のゾーン情報
   */
  function ImportMember(rawMember, _ref) {
    var zoneInfo = _ref.zoneInfo;
    (0, _classCallCheck2.default)(this, ImportMember);
    this.zoneInfo = zoneInfo;

    // trim のみ（名前間のスペースは保持）
    this.fullName = this._trimOnly(rawMember.fullName);
    this.fullNameFurigana = this._trimOnly(rawMember.fullNameFurigana);
    this.companyNameFurigana = this._trimOnly(rawMember.companyNameFurigana);

    // trim のみ
    this.companyName = this._trimOnly(rawMember.companyName);
    this.position = this._trimOnly(rawMember.position);

    // zenkaku2hankaku + dash置換
    this.phoneNumber = this._toHankakuWithDash(rawMember.phoneNumber);
    this.mobilePhone = this._toHankakuWithDash(rawMember.mobilePhone);
    this.fax = this._toHankakuWithDash(rawMember.fax);
    this.postcode = this._toHankakuWithDash(rawMember.postcode);

    // zenkaku2hankaku のみ
    this.email = this._toHankaku(rawMember.email);
    this.website = this._toHankaku(rawMember.website);
    this.address1 = this._toHankaku(rawMember.address1);
    this.address2 = this._toHankaku(rawMember.address2);

    // Number変換
    this.employees = this._toNumberOrNull(rawMember.employees);
    this.employeesPartTime = this._toNumberOrNull(rawMember.employeesPartTime);

    // 日付（バリデーター側で正規化済み）
    this.joinDate = rawMember.joinDate != null ? rawMember.joinDate : null;
    this.established = rawMember.established != null ? rawMember.established : null;
    this.birthday = zoneInfo.app_allow_show_birthday ? this._toDateString(rawMember.birthday) : null;

    // 文字列化
    this.memberId = rawMember.memberId != null ? String(rawMember.memberId) : null;
    this.industryCode = rawMember.industryCode != null ? String(rawMember.industryCode) : null;
    this.capitalStock = rawMember.capitalStock != null ? String(rawMember.capitalStock) : null;

    // パスワード（暗号化は出力時）
    this.password = rawMember.password != null ? String(rawMember.password) : null;

    // そのまま
    this.businessDescriptions = rawMember.businessDescriptions != null ? rawMember.businessDescriptions : null;
  }

  /**
   * 新規ユーザー登録用の user_insert_input オブジェクトを生成する。
   * @returns {Object} Hasura の user_insert_input 形式
   */
  return (0, _createClass2.default)(ImportMember, [{
    key: "toNewUserJson",
    value: function toNewUserJson() {
      return {
        avatar: null,
        full_name: this.fullName,
        full_name_furigana: this.fullNameFurigana,
        position: this.position,
        mobile_phone: '',
        id: this.memberId,
        password: (0, _user.encrypt)(this.password),
        is_display: true,
        is_active: true,
        birthday: this.birthday,
        company: {
          data: {
            name: this.companyName,
            name_furigana: this.companyNameFurigana,
            industry: this.industryCode,
            phone_number: this.phoneNumber,
            mobile_phone: this.mobilePhone,
            fax: this.fax,
            email: this.email,
            website: this.website,
            postcode: this.postcode,
            address_1: this.address1,
            address_2: this.address2,
            business_descriptions: this.businessDescriptions,
            capital_stock: this.capitalStock,
            employees: this.employees,
            employees_part_time: this.employeesPartTime,
            established: this.established,
            join_date: this.joinDate
          }
        }
      };
    }

    /**
     * 既存ユーザー更新用のオブジェクトを生成する。値が null のフィールドは含まない。
     * @param {{ uid: string, company_id: number }} existingUser - 既存ユーザー情報
     * @returns {{ uid: string, company_id: number, user_set: Object, company_set: Object }}
     */
  }, {
    key: "toUpdateJson",
    value: function toUpdateJson(existingUser) {
      var user_set = {};
      var company_set = {};
      if (this.fullName != null) user_set.full_name = this.fullName;
      if (this.fullNameFurigana != null) user_set.full_name_furigana = this.fullNameFurigana;
      if (this.position != null) user_set.position = this.position;
      if (this.password != null) user_set.password = (0, _user.encrypt)(this.password);
      if (this.birthday != null) user_set.birthday = this.birthday;
      if (this.companyName != null) company_set.name = this.companyName;
      if (this.companyNameFurigana != null) company_set.name_furigana = this.companyNameFurigana;
      if (this.industryCode != null) company_set.industry = this.industryCode;
      if (this.phoneNumber != null) company_set.phone_number = this.phoneNumber;
      if (this.mobilePhone != null) company_set.mobile_phone = this.mobilePhone;
      if (this.fax != null) company_set.fax = this.fax;
      if (this.email != null) company_set.email = this.email;
      if (this.website != null) company_set.website = this.website;
      if (this.postcode != null) company_set.postcode = this.postcode;
      if (this.address1 != null) company_set.address_1 = this.address1;
      if (this.address2 != null) company_set.address_2 = this.address2;
      if (this.businessDescriptions != null) company_set.business_descriptions = this.businessDescriptions;
      if (this.capitalStock != null) company_set.capital_stock = this.capitalStock;
      if (this.employees != null) company_set.employees = this.employees;
      if (this.employeesPartTime != null) company_set.employees_part_time = this.employeesPartTime;
      if (this.established != null) company_set.established = this.established;
      if (this.joinDate != null) company_set.join_date = this.joinDate;
      return {
        uid: existingUser.uid,
        company_id: existingUser.company_id,
        user_set: user_set,
        company_set: company_set
      };
    }

    /**
     * 更新対象のフィールドがあるかどうかを返す。
     * @param {{ uid: string, company_id: number }} existingUser - 既存ユーザー情報
     * @returns {boolean}
     */
  }, {
    key: "hasUpdates",
    value: function hasUpdates(existingUser) {
      var update = this.toUpdateJson(existingUser);
      return Object.keys(update.user_set).length > 0 || Object.keys(update.company_set).length > 0;
    }

    // --- Private helpers ---
  }, {
    key: "_trimOnly",
    value: function _trimOnly(v) {
      if (v == null) return null;
      return v.toString().trim();
    }
  }, {
    key: "_toHankakuWithDash",
    value: function _toHankakuWithDash(v) {
      if (v == null) return null;
      return _memberImportValidator.MemberImportValidator.zenkaku2hankaku(v.toString().trim()).replace('−', '-').replace('−', '-');
    }
  }, {
    key: "_toHankaku",
    value: function _toHankaku(v) {
      if (v == null) return null;
      return _memberImportValidator.MemberImportValidator.zenkaku2hankaku(v.toString().trim());
    }
  }, {
    key: "_toNumberOrNull",
    value: function _toNumberOrNull(v) {
      if (v && (0, _checkExt.checkIsNumber)(v) && v !== 'null') {
        return Number(v);
      }
      return null;
    }
  }, {
    key: "_toDateString",
    value: function _toDateString(v) {
      if (v == null) return null;
      if (v instanceof Date) {
        var y = v.getFullYear();
        var m = String(v.getMonth() + 1).padStart(2, '0');
        var d = String(v.getDate()).padStart(2, '0');
        return "".concat(y, "-").concat(m, "-").concat(d);
      }
      return String(v).trim();
    }
  }]);
}();